import * as Joi from "joi";
import { Column, Entity, JoinColumn, OneToOne } from 'typeorm';
import EpisodicActorNoteBase from '../episodic-actor-note-base.entity';
import EpisodicActor from '../episodic-actors/episodic-actor.entity';

@Entity('cm_episodic_actors')
export default class CmEpisodicActor extends EpisodicActorNoteBase {
	static tableName = 'cm_episodic_actors';

	@Column('varchar')
	cm_note: string;

	@OneToOne(
		(type) => EpisodicActor,
		(episodicActor) => episodicActor.cmEpisodicActor
	)
	@JoinColumn({
		name: 'episodic_actor_id',
	})
	episodicActor: EpisodicActor;

	static rules() {
		return {
			...EpisodicActorNoteBase.rules(),
			cm_note: Joi.string().allow(null, ''),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			cm_note: this.cm_note,
		};
	}

	set note(note: string) {
		this.cm_note = note;
	}

	get note() {
		return this.cm_note;
	}
}
